module.exports = __webpack_public_path__ + "src/assets/img/3_5art_1part.376f5a6a.jpg";